var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-touchable',_vm._b({attrs:{"px":"4","py":"2","display":"flex","alignItems":"center","bg":{
    _: _vm.selected ? 'gray-100' : 'transparent',
    hover: 'gray-100',
    focus: 'gray-100'
  }},on:{"click":function($event){return _vm.$emit('click')}}},'v-touchable',_vm.$attrs,false),[(_vm.icon)?_c('v-icon',{attrs:{"icon":_vm.icon,"mr":"3"}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }